import { useEffect } from "react";
import { useNavigate } from "react-router-dom";
import { motion } from "framer-motion";
import { Store, ShieldCheck, Clock } from "lucide-react";
import ProstoHeader from "@/prosto/ProstoHeader";
import ProstoInstallGuide from "@/prosto/ProstoInstallGuide";

export default function ProstoGuide() {
  const navigate = useNavigate();

  useEffect(() => {
    window.scrollTo(0, 0);
  }, []);

  return (
    <div className="pb-24" data-testid="prosto-guide-page">
      <ProstoHeader title="Как установить" back />

      <div className="px-4 pt-5">
        {/* Hero */}
        <motion.div
          initial={{ opacity: 0, y: 16 }}
          animate={{ opacity: 1, y: 0 }}
          className="relative overflow-hidden rounded-3xl bg-gradient-to-br from-[#2F6BFF] to-[#1E4FD6] p-5 shadow-xl shadow-blue-500/20"
        >
          <div className="relative z-10 max-w-[64%]">
            <h1 className="font-display text-2xl font-extrabold text-white leading-tight">
              Как установить приложение
            </h1>
            <p className="mt-2 text-[13px] text-blue-100 leading-relaxed">
              Всего 4 простых шага. Вход только в «Контент и покупки» — iCloud не трогаем.
            </p>
          </div>
          <img
            src="/assets/steps/hero-phone.jpg"
            alt=""
            className="pointer-events-none absolute -right-6 -bottom-8 w-40 opacity-90 drop-shadow-2xl"
          />
        </motion.div>

        {/* Reassurance */}
        <motion.div
          initial={{ opacity: 0, y: 16 }}
          animate={{ opacity: 1, y: 0 }}
          transition={{ delay: 0.05 }}
          data-testid="prosto-guide-safe-banner"
          className="mt-4 flex items-start gap-3 rounded-2xl bg-emerald-50 border border-emerald-200 p-4"
        >
          <span className="shrink-0 grid place-items-center w-9 h-9 rounded-xl bg-emerald-100 text-emerald-600">
            <ShieldCheck size={20} />
          </span>
          <div className="text-[13px] leading-relaxed text-emerald-800">
            <b className="font-bold">Ничего не удалится.</b> При выходе из Apple ID все ваши фото, контакты, заметки и
            данные остаются на телефоне — вы выходите только из App Store, а не из iCloud.
          </div>
        </motion.div>

        {/* Timing hint */}
        <div className="mt-3 flex items-center gap-2 text-xs text-slate-500 px-1">
          <Clock size={14} className="text-[#2F6BFF]" />
          Занимает около 2 минут
        </div>

        {/* Steps */}
        <section className="mt-5">
          <ProstoInstallGuide />
        </section>

        {/* CTA */}
        <motion.button
          initial={{ opacity: 0 }}
          whileInView={{ opacity: 1 }}
          viewport={{ once: true }}
          data-testid="prosto-guide-choose-app-button"
          onClick={() => navigate("/prosto/search")}
          className="mt-6 w-full flex items-center justify-center gap-2 py-3.5 rounded-2xl font-bold text-white bg-[#2F6BFF] active:scale-95 transition shadow-lg shadow-blue-500/25"
        >
          <Store size={18} /> Выбрать приложение
        </motion.button>
      </div>
    </div>
  );
}
